export const applicanttrackingjobskillsdata = [
  {
    skill: "JavaScript",
    category: "Software Development",
    status: "Active",
    description:
      "A popular programming language used primarily for web development to create interactive web pages.",
    created_date: "2025-01-20",
  },
  {
    skill: "Data Analysis",
    category: "Data Science",
    status: "Active",
    description:
      "The process of inspecting, cleaning, transforming, and modeling data to discover useful information.",
    created_date: "2024-12-05",
  },
  {
    skill: "Project Management",
    category: "Business Management",
    status: "Inactive",
    description:
      "The process of leading a team to achieve specific goals within a project’s scope and timeline.",
    created_date: "2024-06-15",
  },
  {
    skill: "Machine Learning",
    category: "Data Science",
    status: "Active",
    description:
      "A subset of artificial intelligence that allows systems to learn from data and improve over time.",
    created_date: "2025-02-10",
  },
  {
    skill: "UI/UX Design",
    category: "Design",
    status: "Active",
    description:
      "The process of designing user interfaces and user experiences for applications and websites.",
    created_date: "2024-09-25",
  },
  {
    skill: "Cloud Computing",
    category: "Technology",
    status: "Active",
    description:
      "The delivery of computing services like storage, processing, and software over the internet.",
    created_date: "2025-01-05",
  },
  {
    skill: "SEO (Search Engine Optimization)",
    category: "Marketing",
    status: "Active",
    description:
      "The practice of optimizing websites to rank higher in search engine results and increase organic traffic.",
    created_date: "2024-08-30",
  },
  {
    skill: "Cybersecurity",
    category: "Technology",
    status: "Active",
    description:
      "The practice of protecting systems, networks, and data from digital attacks or unauthorized access.",
    created_date: "2025-03-01",
  },
  {
    skill: "Digital Marketing",
    category: "Marketing",
    status: "Active",
    description:
      "The use of online platforms and digital tools to promote products and services to targeted audiences.",
    created_date: "2024-07-18",
  },
  {
    skill: "Salesforce",
    category: "Sales",
    status: "Active",
    description:
      "A customer relationship management (CRM) platform that helps businesses manage their sales and customer data.",
    created_date: "2024-11-10",
  },
  {
    skill: "Data Visualization",
    category: "Data Science",
    status: "Active",
    description:
      "The graphical representation of information and data to make insights more accessible and understandable.",
    created_date: "2024-12-22",
  },
  {
    skill: "Team Leadership",
    category: "Business Management",
    status: "Active",
    description:
      "The ability to lead, guide, and motivate a team towards achieving goals and objectives.",
    created_date: "2024-05-05",
  },
  {
    skill: "PHP Programming",
    category: "Software Development",
    status: "Inactive",
    description:
      "A server-side scripting language used for web development and creating dynamic web pages.",
    created_date: "2023-08-15",
  },
  {
    skill: "SQL",
    category: "Database Management",
    status: "Active",
    description:
      "A standardized language for managing and manipulating relational databases.",
    created_date: "2024-10-20",
  },
  {
    skill: "Agile Methodology",
    category: "Project Management",
    status: "Active",
    description:
      "An iterative approach to project management that focuses on collaboration and flexibility.",
    created_date: "2025-01-12",
  },
  {
    skill: "Java",
    category: "Software Development",
    status: "Active",
    description:
      "A widely used object-oriented programming language for building cross-platform applications.",
    created_date: "2024-09-02",
  },
];
